const ORDER_REVIEW = {
  SSL_LABEL: "Secure 256-bit SSL encryption",
  LABELS: {
    BACK: "Back to details",
    EDIT_SHIPPING: "Edit shipping",
    EDIT: "Edit",
    PAGE_TITLE: "Review Your Order",
    SELECTED_ITEM: "Selected Item",
    SHIPPING_ADDRESS: "Shipping address",
    DESTINATION: "DESTINATION",
    CONTACT: "CONTACT",
    PHONE_NUMBER: "Phone Number",
    PAYMENT_METHOD: "Payment Method",
    ORDER_SUMMARY: "Order Summary",
    PRICE: "Price",
    SHIPPING_CHARGE: "Shipping Charge",
    ACTIVATION_CHARGE: "Activation Charge",
    TOTAL_DUE: "Total Due Today",
    CONFIRM: "Confirm & Purchase",
  },
} as const;

export default ORDER_REVIEW;
